class StickyProductForm extends HTMLElement {
  connectedCallback() {
    this.mainButtons = document.querySelector('.product-form__buttons');
    if (!this.mainButtons) return;

    // Set initial state
    this.lastScrollY = window.scrollY;

    this.setupIntersectionObserver();
    this.setupScrollListener();
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(([{ isIntersecting }]) => {
      this.classList.toggle('translate-y-full', isIntersecting);
      this.classList.toggle('opacity-0', isIntersecting);

      if (!isIntersecting && window.innerWidth < 768) {
        this.chatButtonPlaceholder = document.querySelector('gorgias-chat-loader button');
        this.chatButton = document.querySelector('iframe#chat-button');
        this.launcherButton = document.querySelector('.R-LauncherButton');

        const elements = [this.chatButtonPlaceholder, this.chatButton, this.launcherButton];

        // Set bottom position for each element that would overlap with the sticky bar
        elements.forEach((element) => {
          if (!element) return;
          if (isIntersecting) {
            element.style.bottom = '';
          } else {
            element.style.transition = 'bottom 0.3s';
            element.style.bottom = '100px';
          }
        });
      }
    });
    this.observer.observe(this.mainButtons);
  }

  setupScrollListener() {
    this.handleScroll = () => {
      const scrollInfo = this.getScrollInfo();
      const mainButtonsVisibility = this.checkMainButtonsVisibility();
      this.updateStickyBarVisibility(scrollInfo, mainButtonsVisibility);
      this.lastScrollY = scrollInfo.currentScrollY;
    };

    window.addEventListener('scroll', this.handleScroll);
  }

  getScrollInfo() {
    const currentScrollY = window.scrollY;
    const scrollingUp = currentScrollY < this.lastScrollY;
    const bottomReached =
      window.innerHeight + Math.round(currentScrollY) >=
      document.documentElement.scrollHeight - 200;

    return { currentScrollY, scrollingUp, bottomReached };
  }

  checkMainButtonsVisibility() {
    const mainButtonsRect = this.mainButtons.getBoundingClientRect();
    return mainButtonsRect.top < window.innerHeight && mainButtonsRect.bottom >= 0;
  }

  updateStickyBarVisibility({ bottomReached, scrollingUp }, mainButtonsVisible) {
    const shouldHide = (bottomReached && !scrollingUp) || mainButtonsVisible;
    this.classList.toggle('translate-y-full', shouldHide);
    this.classList.toggle('opacity-0', shouldHide);

    if (window.innerWidth < 768) {
      const bottomPosition = shouldHide ? '' : '100px';
      if (this.chatButton) this.chatButton.style.bottom = bottomPosition;
      if (this.launcherButton) this.launcherButton.style.bottom = bottomPosition;
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('scroll', this.handleScroll);
    if (this.chatButton) this.chatButton.style.bottom = '';
    if (this.launcherButton) this.launcherButton.style.bottom = '';
  }
}

customElements.define('sticky-add-to-cart', StickyProductForm);
